import React, { useState } from "react";
import styled from "styled-components";
import DrawerRecording from "../../../internal/ViewRecording/ViewRecording";
import AudioRecordings from "../../../internal/MeetingAudioDetails/index";
import { Strip, TabBtn, TabLabel } from "./CaseTabStrip";
import {
  ControlsRow,
  ControlsGroup,
  CardSlot,
  LinkSlot,
} from "../../../pages/CaseDetails";
import { HyperLink } from "../../ClaimItemsListModal";
import { PrimaryCTAButton } from "../../Buttons";
import MeetingAccess from "../../../pages/CaseDetails/common/MeetingControl";
import RecordingControl from "../../../pages/CaseDetails/common/RecordingControl";
import TranscriptionControl from "../../../pages/CaseDetails/common/TranscriptionControl";
import { navigate } from "@reach/router";
import _ from "lodash";

export default function HearingsAndTranscrips({
  open,
  setOpen,
  caseId,
  id = "",
  heading = "Hearings & Transcripts",
  type,
  viewOnly,

  // hearings

  state,
  isActionsDisabled,
  isNonNegotiation,
  isNotDraft,
  mediatorTitle,
  meetingOpen,
  setSettingsModal,
  setPublicModal,
  transcriptControl,
  settranscriptControl,
  setRefreshDetails,
  meetingDetail,
  stopTranscriptionAlert = () => {},
  pushCaseToArbitrationAlert = () => {},
  caseDetails,
  tab,
  setState,
  startTranscription = () => {},
  setRefreshStatus,
  generateRTMPLink = () => {},
  MTRef,
  joinMeetingAlert = () => {},
}) {
  const [activeTab, setActiveTab] = useState("viewRecordings");

  return (
    <>
      <ControlsRow>
        <ControlsGroup>
          {/* Transcription & Cross-Examination — only when meeting is open */}
          {meetingOpen && isNonNegotiation && (
            <>
              <CardSlot>
                <>
                  <PrimaryCTAButton
                    style={{ width: "295px" }}
                    onClick={() =>
                      navigate(
                        meetingDetail?.crossExamination
                          ? `/dashboard/case-manager/${caseDetails?.resolutionKind}/${id}/cross-examination`
                          : `/dashboard/case-manager/${caseDetails?.resolutionKind}/${id}/livetranscription`,
                        {
                          state: meetingDetail?.crossExamination
                            ? meetingDetail
                            : {
                                ...caseDetails,
                                interim_results:
                                  meetingDetail?.transcriptionModelParams
                                    ?.interim_results,
                              },
                        },
                      )
                    }
                  >
                    {meetingDetail?.crossExamination
                      ? "Cross Examination"
                      : "Live Transcription"}
                  </PrimaryCTAButton>
                </>
              </CardSlot>

              <CardSlot>
                <>
                  {meetingDetail?.transcriptionRunningStatus ? (
                    <PrimaryCTAButton
                      style={{
                        backgroundColor: "#D04848",
                        border: "1px solid #D04848",
                        width: "295px",
                      }}
                      onClick={() => stopTranscriptionAlert(id)}
                    >
                      Stop Transcription
                    </PrimaryCTAButton>
                  ) : (
                    <PrimaryCTAButton
                      style={{
                        width: "295px",
                      }}
                      onClick={() =>
                        meetingDetail?.isLocalTranscriptionServer === 4
                          ? generateRTMPLink(meetingDetail?.meetingId)
                          : startTranscription(id)
                      }
                    >
                      Start Transcription
                    </PrimaryCTAButton>
                  )}
                </>
              </CardSlot>
            </>
          )}

          {/* Meeting access + recording controls */}
          {isNonNegotiation && (
            <CardSlot>
              <MeetingAccess
                {...{
                  state,
                  setState,
                  id,
                  MTRef,
                  meetingDetail,
                  setRefreshStatus,
                  caseDetails,
                }}
              />
              <RecordingControl
                {...{
                  state,
                  setState,
                  id,
                  MTRef,
                  meetingDetail,
                  caseDetails,
                  setRefreshStatus,
                }}
              />
            </CardSlot>
          )}

          {/* Transcription control */}
          {isNonNegotiation && isNotDraft && (
            <CardSlot>
              <TranscriptionControl
                {...{
                  state,
                  setState,
                  id,
                  MTRef,
                  setRefreshStatus,
                  transcriptControl,
                  settranscriptControl,
                }}
              />
            </CardSlot>
          )}

          {/* Hyperlinks */}
          {isNonNegotiation && isNotDraft && (
            <>
              <LinkSlot>
                <HyperLink onClick={() => setSettingsModal(true)}>
                  Transcription Settings
                </HyperLink>
              </LinkSlot>
              <LinkSlot>
                <HyperLink onClick={() => setPublicModal(true)}>
                  Generate Public Link
                </HyperLink>
              </LinkSlot>
              <CardSlot>
                <PrimaryCTAButton
                  onClick={() =>
                    joinMeetingAlert(
                      caseDetails?.id,
                      caseDetails?.resolutionKind,
                    )
                  }
                  type={`Join ${_.capitalize(caseDetails?.resolutionKind)} Session`}
                >
                  {`Join ${_.capitalize(caseDetails?.resolutionKind)} Session`}
                </PrimaryCTAButton>
              </CardSlot>
            </>
          )}
        </ControlsGroup>
      </ControlsRow>
      <Container>
        <Strip>
          {[
            { label: "View Recordings", id: "viewRecordings" },
            { label: "Audio & Transcript Editor", id: "audioRecordings" },
          ].map((tab) => (
            <TabBtn
              key={tab.id}
              $active={activeTab === tab.id}
              onClick={() => setActiveTab(tab.id)}
            >
              <TabLabel>{tab.label}</TabLabel>
            </TabBtn>
          ))}
        </Strip>
        <Content>
          <TabBody>
            {activeTab === "viewRecordings" &&
              type !== "negotiation" &&
              viewOnly !== true && (
                <DrawerRecording
                  title="View Recordings"
                  id={id}
                  setState={() => {}}
                  type={type}
                />
              )}

            {activeTab === "audioRecordings" &&
              type !== "negotiation" &&
              viewOnly !== true && <AudioRecordings id={id} type={type} />}
          </TabBody>
        </Content>
      </Container>
    </>
  );
}

export const Container = styled.div`
  width: 100%;
  padding: 12px 0;

  @media (max-width: 768px) {
    padding: 8px 0;
  }
`;

export const Content = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
`;

export const TabBody = styled.div`
  padding: 16px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;
